var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.625,
    cy: 14,
    r: 14,
    fill: "#DCEFE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8102 22.7033H10.7622L10.5842 16.1093V16.0973L10.5342 13.8693C10.5182 13.1333 10.6902 12.4013 11.0342 11.7513C11.3742 11.1073 11.8742 10.5573 12.4802 10.1593C12.5262 10.1293 12.5502 10.0833 12.5502 10.0253L12.4682 4.86328H16.1142L16.0322 10.0253C16.0322 10.0813 16.0562 10.1273 16.1022 10.1593C16.7082 10.5593 17.2082 11.1093 17.5482 11.7513C17.8922 12.4013 18.0642 13.1333 18.0482 13.8693L17.8102 22.7033ZM11.1502 22.3053H17.4242L17.6522 13.8593C17.6682 13.1933 17.5102 12.5273 17.1982 11.9373C16.8902 11.3533 16.4362 10.8533 15.8842 10.4913C15.7222 10.3853 15.6322 10.2133 15.6342 10.0193L15.7102 5.26328H12.8722L12.9482 10.0193C12.9522 10.2093 12.8582 10.3873 12.6982 10.4913C12.1482 10.8533 11.6942 11.3533 11.3842 11.9373C11.0722 12.5273 10.9162 13.1913 10.9302 13.8593L10.9802 16.0973V16.1093L11.1462 22.3053H11.1502Z",
    fill: "#E3DFD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.214 13.8492L16.998 21.8672H11.578L11.422 16.1112C11.422 16.1112 11.422 16.0932 11.422 16.0852L11.372 13.8492C11.358 13.2552 11.498 12.6652 11.776 12.1412C12.05 11.6232 12.454 11.1772 12.942 10.8552C13.228 10.6672 13.394 10.3512 13.388 10.0112L13.318 5.69922H15.266L15.196 10.0112C15.19 10.3532 15.358 10.6692 15.642 10.8552C16.132 11.1772 16.534 11.6212 16.808 12.1412C17.086 12.6652 17.224 13.2572 17.212 13.8492H17.214Z",
    fill: "#E3DFD7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/White.6499c02994f5417cef01ce19053b57b6.svg";
export { ForwardRef as ReactComponent };